import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { parseDecimal } from '@epi-helpers/numeral';
import { TransferMoneyFormFields } from '@epi-pages/TransferPage/LoadCompanyAccount/helpers';
import {
  getPaymentMinimalValue,
  PaymentMethods
} from '@epi-constants/paymentMethods';
import { getApiPaymentsMethods } from '@epi-selectors/api';
import { IApiPaymentMethods } from '@epi-models/shared';

export const usePaymentMethodOptions = () => {
  const { watch } = useFormContext();

  const apiPaymentMethods: IApiPaymentMethods = useSelector(
    getApiPaymentsMethods
  );
  const getPaymentMinValue = useSelector(state =>
    getPaymentMinimalValue(PaymentMethods.Online)(state)
  );
  const amountValue = watch(TransferMoneyFormFields.Amount).replace(',', '.');

  const calculateTotalAmount = () => parseDecimal(amountValue);
  const isLessThanMinValue = () => {
    return +amountValue < getPaymentMinValue;
  };
  const onlinePaymentMethods = apiPaymentMethods.paymentMethods.filter(
    t => t.type === PaymentMethods.Online
  );

  return {
    calculateTotalAmount,
    apiPaymentMethods,
    isLessThanMinValue,
    onlinePaymentMethods
  };
};
